import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {EAntIconUrl} from '@/assets/ant/icon/enums';

import {EAdminRoutesNames} from './enums';
import {ESettingsFrontType} from '@/config/enums';

export const adminPageRoutes: Array<RouteRecordRaw> = [
  {
    path: 'notification-types',
    name: EAdminRoutesNames.AdminNotificationTypesPage,
    meta: {
      menu: {
        name: 'Типы уведомлений',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminNotificationTypesPage.vue'),
  },
  {
    path: 'notifications',
    name: EAdminRoutesNames.AdminNotificationsPage,
    meta: {
      menu: {
        name: 'Уведомления',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminNotificationsPage.vue'),
  },
  {
    path: 'recipients',
    name: EAdminRoutesNames.AdminRecipientsPage,
    meta: {
      menu: {
        name: 'Получатели',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminRecipientsPage.vue'),
  },
  {
    path: 'subscriptions',
    name: EAdminRoutesNames.AdminSubscriptionsPage,
    meta: {
      menu: {
        name: 'Подписки',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminSubscriptionsPage.vue'),
  },
  {
    path: 'notification-roles',
    name: EAdminRoutesNames.AdminNotificationRolesPage,
    meta: {
      menu: {
        name: 'Роли',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminNotificationRolesPage.vue'),
  },
];
